import { IAccount } from '@/features/accounts/accountSlice'
import IApiResponse from '@/types/api-response';
import IList from '@/types/list-result';
import axios from '@/utils/axios-instance'

export const getAccounts = async (params?: any): Promise<IApiResponse<IList<IAccount>>> => {
	const { data } = await axios.get<IApiResponse<IList<IAccount>>>('/api/account', { params })
	return data
}

export const updateAccount = async (params?: any): Promise<IApiResponse<null | undefined>> => {
	const { data } = await axios.put<IApiResponse<null | undefined>>('/api/account', params)
	return data
}

export const removeAccount = async (params?: any): Promise<IApiResponse<null | undefined>> => {
	const { data } = await axios.delete<IApiResponse<null | undefined>>('/api/account', { params })
	return data
}

export const addAccount = async (params?: any): Promise<IApiResponse<null | undefined>> => {
	const { data } = await axios.post<IApiResponse<null | undefined>>('/api/account', params)
	return data
}

export const addAccountNote = async (params?: any): Promise<IApiResponse<null | undefined>> => {
	const { data } = await axios.post<IApiResponse<null | undefined>>('/api/account/note', params)
	return data
}